export default function animateScroll($element){
	let scrollTop = $element.offset().top - $(".js-product-images").offset().top;

	let targetTop = $(".js-product-images > *").offset().top - $(".js-product-images").offset().top;

	let scrollOffset = scrollTop - targetTop;

	$('.js-section-product').animate(
		{
			scrollTop: scrollOffset
		},
		700
	);
}
